import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../index';
import PropTypes from 'prop-types';

import './dropdown.scss';
import { useParams } from 'react-router-dom';

const Dropdown = ({ ...props }) => {
	const {
		name,
		children,
		title,
		size,
		buttonClass = '',
		clazz,
		clazzWrapper,
		leftIcon,
		openOnHover,
		warning = clazzWrapper,
		arrow = true,
		iconSize,
		iconClass,
		hideOnCHange = false,
		contentClass,
		handleClose = false,
		count = false,
		disabled = false,
		accordion = false,
		hideOnClick = false,
		is_edited = false,
	} = props;

	const [isOpen, setIsOpen] = useState(false);

	const buttonRef = useRef(null);
	const childrenRef = useRef(null);

	useEffect(() => {
		if (hideOnCHange) {
			setIsOpen(false);
		}
	}, [name, title]);

	useEffect(() => {
		if (handleClose) {
			setIsOpen(false);
		}
	}, [handleClose]);

	const handleClickOutside = (event) => {
		if (
			childrenRef.current &&
			!childrenRef.current.contains(event.target) &&
			buttonRef.current &&
			!buttonRef.current.contains(event.target)
		) {
			setIsOpen(false);
			event.stopPropagation();
		}
	};

	const handleHideOnCLick = (e) => {
		if (childrenRef.current && childrenRef.current.contains(e.target)) {
			setIsOpen(false);
			e.stopPropagation();
		}
	};

	useEffect(() => {
		if (hideOnClick) {
			document.addEventListener('mousedown', handleHideOnCLick);
			return () => {
				document.removeEventListener('mousedown', handleHideOnCLick);
			};
		}
	}, []);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div
			onMouseEnter={!!openOnHover ? () => setIsOpen(true) : null}
			onMouseLeave={!!openOnHover ? () => setIsOpen(false) : null}
			className={`dropdown${isOpen ? ' dropdown_active' : ''}${
				clazzWrapper ? ` ${clazzWrapper}` : ''
			}`}
		>
			<div
				className={`button-square ${buttonClass} ${clazz ? ` ${clazz}` : ''} ${disabled ? ' disabled' : ''}`}
				onClick={(e) => {
					e.stopPropagation();
					!disabled && setIsOpen((prev) => !prev);
				}}
				type="button"
				ref={buttonRef}
			>
				{leftIcon ? <Icon spritePath={leftIcon} /> : ''}
				{title}
				{iconClass ? (
					<Icon
						size={iconSize ? iconSize : size}
						clazz={iconClass}
						spritePath={iconClass}
					/>
				) : (
					''
				)}
				{arrow && !iconClass ? (
					<Icon
						size={size}
						clazz={'chevrone'}
						spritePath={'chevrone-down'}
					/>
				) : (
					''
				)}
				{/* {warning && checkedBoxes.length >= 1 ? (
          <span className={"count"}>!</span>
        ) : null} */}
				{(count || is_edited) && (
					<span className={'count lower'}></span>
				)}
			</div>

			<div
				ref={childrenRef}
				className={`dropdown__body ${contentClass ?? ''} ${accordion ? accordion : ''}`}
			>
				{children}
			</div>
		</div>
	);
};

Dropdown.propTypes = {
	size: PropTypes.string,
	children: PropTypes.node,
	buttonClass: PropTypes.string,
	clazzWrapper: PropTypes.string,
};

export default Dropdown;
